import React from 'react'
import { Redirect } from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'

import { dateToUTC } from '../../lib/formats'
import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import ErrorDialog from '../UI/ErrorDialog'
import QuoteForm from './QuoteForm'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')
const QuoteStore = Resource('quotes')

/*
Props:
- projectId: Id of project for quote (also received via props.match.params)
- projectTypeId: Number, the projectTypeId
- name,
  date,
  version,
  description,
  contacts,
  taxRate,
  taxCode,
  notes,
  lineItems: initial quote data
- savedCallback(quote): callback function for sucessful save
- cancelCallback(): callback function for cancellation (default: history.back())
*/
class NewQuote extends React.PureComponent {
  constructor(props) {
    super(props)
    const { match, projectId } = this.props

    this.state = {
      projectId: projectId || match.params.projectId,
      project: null,
      savedQuote: null,
      loading: true,
      error: null,
      snackbarMessage: '',
      redirect: null
    }
  }

  componentWillMount() {
    const { projectId } = this.state
    ProjectStore.find(projectId)
      .then(result =>
        this.setState({
          project: result.data,
          loading: false,
          error: null
        })
      )
      .catch(error =>
        this.setState({
          project: null,
          loading: false,
          error: errors.unpack(error)
        })
      )
  }

  _save = attributes => {
    const { savedCallback } = this.props
    const { project } = this.state

    // Adjust attributes
    attributes.projectId = project.id

    // Create!
    QuoteStore.create(attributes)
      .then(result => {
        const savedQuote = result.data.data
        this.setState(
          {
            error: null,
            savedQuote: savedQuote,
            snackbarMessage: `Quote "${attributes.name}" created!`
          },
          () => {
            if (savedCallback) {
              savedCallback(savedQuote)
            }
          }
        )
      })
      .catch(error => {
        this.setState({
          error: errors.unpack(error)
        })
      })
  }

  _cancel = () => {
    const { cancelCallback } = this.props
    if (!cancelCallback) return window.history.back()
    cancelCallback()
  }

  _closeErrorDialog = () => this.setState({ error: null })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const {
      name,
      date,
      version,
      description,
      contacts,
      taxRate,
      taxCode,
      notes,
      lineItems
    } = this.props

    const {
      project,
      loading,
      error,
      snackbarMessage,
      redirect
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect} />

    const projectTypeId =
      project.attributes.projectTypeId || this.props.projectTypeId
    
    const projectTypeName = project.attributes.projectTypeName
    return (
      <section>
        <PageTitle>
          New quote&nbsp;
          <h3>Project #{project.id}: {project.attributes.name}</h3>
        </PageTitle>

        <QuoteForm
          projectTypeId={projectTypeId}
          projectId={project.id}
	  projectTypeName={projectTypeName}
          name={name || project.attributes.name}
          date={date || dateToUTC(new Date())}
          version={version || 1}
          description={description}
          contacts={contacts}
          taxRate={taxRate}
          taxCode={taxCode}
          notes={notes}
          lineItems={lineItems}
          budget={project.attributes.budget}
          estimatedCost={project.attributes.estimatedCost}
          targetMargin={project.attributes.targetMargin}
          cancelCallback={this._cancel}
          submitCallback={this._save}
        />

        <BackButton style={{ margin: '15px auto 100px auto' }} />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create quote"
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />
      </section>
    )
  }
}

export default NewQuote



// WEBPACK FOOTER //
// ./src/components/Quotes/NewQuote.jsx